export const predictedFileNamePattern = /^[^+:?*\\\";=&|#><^'{}%\[\]]*$/;
